import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { pageLeftThunk } from '@redux/analytics/analyticsThunks';
import { PageType } from '@redux/analytics/analyticsTypes';
import { acceptInviteThunk } from '@redux/oauth/oauthThunks';
import { AcceptAccountInviteRequest } from '@redux/oauth/oauthTypes';
import { CreatePasswordPane } from 'containers/Account/components/DualPane/Panes/CreatePasswordPane/CreatePasswordPane';
import { DevicePaneV2 } from 'containers/Account/components/DualPane/Panes/DevicePaneV2/DevicePaneV2';
import { DualPaneV2 } from 'containers/Account/components/DualPaneV2/DualPaneV2';

type Props = ConnectedProps<typeof connectRedux>;

const CreatePassword: React.FC<Props> = ({ pageLeft, acceptInvite }) => {
  return <DualPaneV2 pageLeft={pageLeft} pageType={PageType.CREATE_PASSWORD} leftPane={() => <CreatePasswordPane acceptInvite={acceptInvite} />} rightPane={<DevicePaneV2 />} />;
};

const connectRedux = connect(
  () => {
    return {};
  },
  (dispatch: Function) => ({
    pageLeft: async (pageType: PageType) => {
      return dispatch(pageLeftThunk(pageType));
    },
    acceptInvite: async (acceptAccountInviteRequest: AcceptAccountInviteRequest, token: any) => {
      return dispatch(acceptInviteThunk(token, acceptAccountInviteRequest));
    }
  })
);

export default compose(connectRedux)(CreatePassword);
